
import { Component, Mixins, Prop } from "vue-property-decorator";
import { formMixin, formOptionsMixin, formValidationMixin } from "../mixins";
import Select from "./Select.vue";
import { getModule } from "vuex-module-decorators";
import { SystemModule } from "@/store/modules";
import BarcodeCompanyModule from "@/store/modules/barcodeSystem/barcodeCompany";

const systemModule = getModule(SystemModule);
const barcodeCompanyModuleState = getModule(BarcodeCompanyModule);

@Component({
  components: {
    Select
  }
})
export default class FacilitySelect extends Mixins(
  formMixin,
  formOptionsMixin,
  formValidationMixin
) {
  @Prop({ default: false })
  appendToBody: boolean;
  @Prop()
  type: string;
  @Prop({ default: false })
  isInactiveIncludeFacilities: boolean;
  @Prop()
  companyId: number;

  get types() {
    let facilityList = systemModule.facilities;
    if (this.companyId !== undefined) {
      const company = this.companyId ? (barcodeCompanyModuleState.companies || []).find(x => x.id === this.companyId) : null;
      const allowedFacilityCodes = company ? company.facilityCodes : [];
      facilityList = facilityList.filter(item => allowedFacilityCodes.includes(item.facilityCode));
    }
    return facilityList.filter(item => item.facilityCode).map(x => ({ label: `${this.getActiveText(x.isActive)} ${this.getFacilityNameText(x.name)} (${x.facilityCode})`, value: x.facilityCode, isActive: x.isActive }));
  }
  getFacilityNameText(facilityName) {
    return facilityName || 'Facility name not available';
  }
  getCompanyNameText(companyName) {
    return companyName || 'Company name not available';
  }
  getActiveText(isActive) {
    return isActive ? '' : 'Inactive ';
  }
}
